import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as r } from "react";
const n = ({
  title: l,
  titleId: o,
  ...i
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M690.462 510.895c0 10.923-4.16 21.824-12.501 30.165L408.521 810.5c-16.661 16.661-43.691 16.661-60.331 0-16.683-16.661-16.683-43.669 0-60.331l239.275-239.275-239.189-239.189c-16.661-16.661-16.661-43.669 0-60.331s43.669-16.661 60.331 0l269.355 269.355c8.341 8.341 12.501 19.243 12.501 30.165z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = r(n);
export {
  m as default
};
